import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { StyleSheetManager } from 'styled-components';
import { FrameContext } from 'react-frame-component';

export default function InjectedFrameStyles({ children }) {
    const { document } = useContext(FrameContext);
    return <StyleSheetManager target={document.head}>{children}</StyleSheetManager>;
}

InjectedFrameStyles.propTypes = {
    children: PropTypes.node.isRequired,
};
